import React from 'react'
import { Route, Routes, BrowserRouter, Navigate, useLocation } from 'react-router-dom'
import DashboardExample from '../pages/DashboardExample'
import Dashboard from '../pages/Dashboard'
import SignIn from '../pages/SignIn'
import Transactions from 'pages/Transactions'
import Details from 'pages/Details'
import Status from 'pages/Status'
import RulesPlan from 'pages/RulesPlan'
import RulesPlanGroupEdit from 'pages/RulesPlanGroupEdit'
import RulesPlanRiskEdit from 'pages/RulesPlanRiskEdit'
import AdminPlans from 'pages/AdminPlans'
import PolicyGovernance from 'pages/PolicyGovernance'
import AdminTenancy from 'pages/AdminTenancy'
import Layout from 'components/shared/Layout'
import { isAuthenticationEnabled, hasAllCapabilities, isUserAuthenticated } from 'helpers/authSession'
import { routePaths, SCREEN_ACCESS_MATRIX } from 'config/navigation'

export const PrivateRoute = ({ children, requiredCapabilities = [] }) => {
  const location = useLocation();

  if (!isAuthenticationEnabled()) {
    return children;
  }

  if (!isUserAuthenticated()) {
    return <Navigate to={routePaths.login} replace state={{ from: location }} />;
  }

  if (!hasAllCapabilities(requiredCapabilities)) {
    return <Navigate to={routePaths.dashboard} replace />;
  }

  return children;
}

const LoginRoute = () => {
  if (!isAuthenticationEnabled()) {
    return <Navigate to={routePaths.dashboard} replace />;
  }

  if (isAuthenticationEnabled() && isUserAuthenticated()) {
    return <Navigate to={routePaths.dashboard} replace />;
  }

  return <SignIn />;
}

const RoutesConfig = () => (
  <BrowserRouter>
    <Routes>
      <Route path={routePaths.login} element={<LoginRoute />} exact />
      <Route path={routePaths.root} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.dashboard.routeCapabilities}><Layout><Dashboard /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.dashboard} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.dashboard.routeCapabilities}><Layout><Dashboard /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.transactions} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.transactions.routeCapabilities}><Layout><Transactions /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.detailsById} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.transactionDetails.routeCapabilities}><Layout><Details /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.status} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.transactionStatus.routeCapabilities}><Layout><Status /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.rulesPlan} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.clientRules.routeCapabilities}><Layout><RulesPlan /></Layout></PrivateRoute>} exact />
      <Route path={routePaths.rulesPlanGroupEdit} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.clientRulesEdit.routeCapabilities}><Layout><RulesPlanGroupEdit /></Layout></PrivateRoute>} />
      <Route path={routePaths.rulesPlanRiskEdit} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.clientRulesEdit.routeCapabilities}><Layout><RulesPlanRiskEdit /></Layout></PrivateRoute>} />
      <Route
        path={routePaths.adminPlans}
        element={(
          <PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.adminPlans.routeCapabilities}>
            <Layout>
              <AdminPlans />
            </Layout>
          </PrivateRoute>
        )}
        exact
      />
      <Route
        path={routePaths.policyGovernance}
        element={(
          <PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.policyGovernance.routeCapabilities}>
            <Layout>
              <PolicyGovernance />
            </Layout>
          </PrivateRoute>
        )}
        exact
      />
      <Route
        path={routePaths.adminTenancy}
        element={(
          <PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.adminTenancy.routeCapabilities}>
            <Layout>
              <AdminTenancy />
            </Layout>
          </PrivateRoute>
        )}
        exact
      />
      <Route path={routePaths.example} element={<PrivateRoute requiredCapabilities={SCREEN_ACCESS_MATRIX.example.routeCapabilities}><Layout><DashboardExample /></Layout></PrivateRoute>} exact />
    </Routes>
  </BrowserRouter>
)

export default RoutesConfig;
